<!-- [rows]="10" -->
<!-- id="table" [resizableColumns]="true"  "{ 'min-width': '50rem' }" -->

<!-- [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-striped p-datatable-gridlines" -->


<p-table #dt [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]='paginationRequest.pageSize' [totalRecords]='paginationResult.filteredEntities'
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [loading]="loading" [rowHover]="true"
  [scrollable]="true" scrollHeight="calc(100vh - 320px)" [tableStyle]="{ 'min-width': '50rem'  }" scrollWidth="100%"
    [showCurrentPageReport]="true" currentPageReportTemplate="
      {{ 'table.showing' | translate }} {first}
      {{ 'table.to' | translate }} {last}
      {{ 'table.of' | translate }} {totalRecords}
      {{ 'table.entries' | translate}}" class="custom-table custom-tablevehicles"
  [globalFilterFields]="['name','brand.name','model.name','version.name','type.name','frameNumber','status.name','billingAccount.name']"
  [filters]="vehicleTableFilters" sortField="name" [sortOrder]="1" (onFilter)="onFilterApplied($event)"
  [resizableColumns]="true" columnResizeMode="expand"
  [reorderableColumns]="true" (onColReorder)="onColReorder($event)">

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
   
  <div class="d-flex align-items-center justify-content-between text-uppercase"
    [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <div class="filters-summary">
      @for (column of filteredColumns; track column) {
      <div class="filter-badge">
        <span class="filter-text" title="{{ column.fieldtrans }}: {{ formatValue(column.field, column.value) }}">
          {{ column.fieldtrans}}: {{ formatValue(column.field, column.value) }}
          <button (click)="clearFilter(column.field)" class="clear-button">✖</button>
        </span>
      </div>
      }
      @if (filteredColumns.length) {
      <button class="btn custom-button" (click)="clearAllFilters()">{{ 'general.filters.clearall' | translate }}</button>
      }
    </div>


    <div class="d-flex align-items-center justify-content-center text-uppercase mb-4 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      {{ 'tableManagement.vehicle.vehiclesManagement' | translate }}
    </div>


    <app-table-user-settings [columns]="columns" [selectedColumns]="_selectedColumns"
      (selectedColumnsChange)="onSelectedColumnsChange($event)" (saveColumns)="saveColumnVisibility()">
    </app-table-user-settings>

  </div>

  </ng-template>
  <!-- #endregion -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- CAR LICENSE PLATE (frozen, always first) -->
      <th pResizableColumn pSortableColumn="name" class="table-column custom-columns-small" pFrozenColumn style=" justify-content: center;border-right: 1px solid #8898AA !important;">
        <div class='d-flex align-items-center h-100'>
          <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
            {{ 'control-panel.vehicles.licensePlate' | translate }}
          </div>
          <div class="d-flex align-items-center h-100">
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="name"></p-sortIcon>
              <p-columnFilter field="name" type="text" matchMode="contains"
                placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                [showOperator]="false" [showAddButton]="false">
              </p-columnFilter>
            </div>
          </div>
        </div>
      </th>

      @for (field of orderedVisibleFields; track field) {
        @switch (field) {

          @case ('model.brand.name') {
            <th pResizableColumn pReorderableColumn pSortableColumn="model.brand" class="table-column custom-columns-small" style="text-align: center ; ">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.brands.brand' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="model.brand"></p-sortIcon>
                    <p-columnFilter field="brand" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" [options]="brandList"
                          placeholder="{{ 'general.filters.any' | translate }}"
                          (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="option.name" tooltipPosition="right" class="p-multiselect-brand-option">
                              @if (option?.logo?.imageEncoded) {
                                <img id='uploadedImage' alt=''
                                  [src]="'option.logo.imageEncoded'"
                                  [style]="{'vertical-align':'middle', 'max-height':'32px', 'width':'32px', 'margin-right':'10px'}">
                              }
                              @if (!option?.logo?.imageEncoded) {
                                <img id='uploadedImage' alt=''
                                  [src]="'assets/icons/no-image-available.svg'"
                                  [style]="{'vertical-align':'middle', 'max-height':'32px', 'width':'32px', 'margin-right':'10px'}">
                              }
                              <span class="ml-1">{{option.name}}</span>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('model.name') {
            <th pResizableColumn pReorderableColumn pSortableColumn="model" class="table-column custom-columns-small" style=" text-align: center ;">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.models.model' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="model"></p-sortIcon>
                    <p-columnFilter field="model" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" [options]="modelList"
                          placeholder="{{ 'general.filters.any' | translate }}"
                          (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="option.name" tooltipPosition="right" class="p-multiselect-model-option">
                              <span class="ml-1">{{option.name}}</span>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('version.name') {
            <th pResizableColumn pReorderableColumn pSortableColumn="version" class="table-column custom-columns-medium" style=" text-align: center ;">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.versions.version' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="version"></p-sortIcon>
                    <p-columnFilter field="version" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" [options]="versionList"
                          placeholder="{{ 'general.filters.any' | translate }}"
                          (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="option.name" tooltipPosition="right" class="p-multiselect-version-option">
                              <span class="ml-1">{{option.name}}</span>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('frameNumber') {
            <th pResizableColumn pReorderableColumn pSortableColumn="frameNumber" class="table-column custom-columns-big">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'control-panel.vehicles.frameNumber' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="frameNumber"></p-sortIcon>
                    <p-columnFilter field="frameNumber" type="text" matchMode="contains"
                      placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false">
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('status.name') {
            @if (isVehicleStateGranted) {
              <th pResizableColumn pReorderableColumn pSortableColumn="status" class="table-column custom-columns-big">
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                    {{ 'tableManagement.vehicleStatus.vehicleStatus' | translate }}
                  </div>
                  <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center h-100">
                      <p-sortIcon field="status"></p-sortIcon>
                      <p-columnFilter field="status" matchMode="in" display="menu" [showMatchModes]="false"
                        [showOperator]="false" [showAddButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" [options]="vehicleStatusList"
                            placeholder="{{ 'general.filters.any' | translate }}"
                            (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                            <ng-template let-option pTemplate="item">
                              <div [pTooltip]="option.name" tooltipPosition="right" class='d-flex row-cols-2 w-100 align-items-center'>
                                <div class="status-marcha" [style]="{'--color': option.color }"></div>
                                <div>{{ option.name }}</div>
                              </div>
                            </ng-template>
                          </p-multiSelect>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                  </div>
                </div>
              </th>
            }
          }

          @case ('driver.employee.code') {
            <th pResizableColumn pReorderableColumn pSortableColumn="driver.employee.code" class="table-column custom-columns-medium">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'drivers.driverCode' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <p-sortIcon field="driver.employee.code"></p-sortIcon>
                  <p-columnFilter field="driverCode" type="text" matchMode="contains"
                    placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                </div>
              </div>
            </th>
          }

          @case ('driver.employee.user.name') {
            <th pResizableColumn pReorderableColumn pSortableColumn="driver.employee.user.name" class="table-column custom-columns-big">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'drivers.driverName' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <p-sortIcon field="driver.employee.user.name"></p-sortIcon>
                  <p-columnFilter field="driverName" type="text" matchMode="contains"
                    placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                </div>
              </div>
            </th>
          }

          @case ('billingAccount.code') {
            <th pResizableColumn pReorderableColumn pSortableColumn="billingAccount.code" class="table-column custom-columns-small">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'general.code' | translate }} {{ 'tableManagement.companies.company' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="billingAccount.code"></p-sortIcon>
                    <p-columnFilter field="billingAccount" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" [options]="companiesList"
                          placeholder="{{ 'general.filters.any' | translate }}"
                          (onChange)="filter($event.value)" optionLabel="code" optionValue="id">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="option.code" tooltipPosition="right"><span class="ml-1">{{option.code}}</span></div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('billingAccount.name') {
            <th pResizableColumn pReorderableColumn pSortableColumn="billingAccount.name" class="table-column custom-columns-big">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.companies.company' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="billingAccount.name"></p-sortIcon>
                    <p-columnFilter field="billingAccount" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" [options]="companiesList"
                          placeholder="{{ 'general.filters.any' | translate }}"
                          (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="'(' + option.code + ') ' + option.name" tooltipPosition="right"><span class="ml-1">({{option.code}}) {{option.name}}</span></div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('delegation.code') {
            <th pResizableColumn pReorderableColumn pSortableColumn="subDelegation.delegation.code" class="table-column custom-columns-medium">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'general.code' | translate }} {{ 'tableManagement.delegations.delegation' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="subDelegation.delegation.name"></p-sortIcon>
                    <p-columnFilter field="delegation" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" [options]="delegationList"
                          placeholder="{{ 'general.filters.any' | translate }}"
                          (onChange)="filter($event.value)" optionLabel="code" optionValue="id">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="option.code" tooltipPosition="right"><span class="ml-1">{{option.code}}</span></div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('delegation.name') {
            <th pResizableColumn pReorderableColumn pSortableColumn="subDelegation.delegation.name" class="table-column custom-columns-medium">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.delegations.delegation' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="subDelegation.delegation.name"></p-sortIcon>
                    <p-columnFilter field="delegation" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" [options]="delegationList"
                          placeholder="{{ 'general.filters.any' | translate }}"
                          (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="'(' + option.code + ') ' + option.name" tooltipPosition="right"><span class="ml-1">({{option.code}}) {{option.name}}</span></div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('ceco.code') {
            <th pResizableColumn pReorderableColumn pSortableColumn="ceco.code" class="table-column custom-columns-medium">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'general.code' | translate }} {{ 'drivers.table.ceco' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="ceco.description"></p-sortIcon>
                    <p-columnFilter [showApplyButton]="true" field="ceco" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body" [hideOnClear]="true">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" (onChange)="filter($event.value);" [filter]="true"
                          [options]="cecoList" placeholder="{{ 'general.filters.any' | translate }}"
                          [virtualScroll]="true" itemSize="30" optionLabel="code" optionValue="id"
                          [showToggleAll]="false" [panelStyle]="{'min-width': '350px'}">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="option.code" tooltipPosition="right"><span class="ml-1">{{option.code}}</span></div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('ceco.description') {
            <th pResizableColumn pReorderableColumn pSortableColumn="ceco.description" class="table-column custom-columns-big">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'drivers.table.ceco' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="ceco.description"></p-sortIcon>
                    <p-columnFilter [showApplyButton]="true" field="ceco" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body" [hideOnClear]="true">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" (onChange)="filter($event.value);" [filter]="true"
                          [options]="cecoList" placeholder="{{ 'general.filters.any' | translate }}"
                          [virtualScroll]="true" itemSize="30" optionLabel="description" optionValue="id"
                          [showToggleAll]="false" [panelStyle]="{'min-width': '350px'}">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="option.description" tooltipPosition="right"><span class="ml-1">{{option.description}}</span></div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('financing.financingType.name') {
            <th pResizableColumn pReorderableColumn pSortableColumn="financing.financingType.name" class="table-column custom-columns-big">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.financing.financingType' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="renting"></p-sortIcon>
                    <p-columnFilter [showApplyButton]="true" field="renting" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body" [hideOnClear]="true">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect styleClass="column-filter-select" panelStyleClass="column-filter-select-panel" [ngModel]="value" (onChange)="filter($event.value);" [filter]="true"
                          [options]="financingTypeList" placeholder="{{ 'general.filters.any' | translate }}"
                          [virtualScroll]="true" itemSize="30" optionLabel="name" optionValue="value"
                          [showToggleAll]="false" [panelStyle]="{'min-width': '350px'}">
                          <ng-template let-option pTemplate="item">
                            <div [pTooltip]="option.name" tooltipPosition="right"><span class="ml-1">{{option.name}}</span></div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('financing.provider.name') {
            <th pResizableColumn pReorderableColumn pSortableColumn="financing.provider.name" class="table-column custom-columns-big">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.financing.financing' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="financing.provider.name"></p-sortIcon>
                    <p-columnFilter field="financingProvider" type="text" matchMode="contains"
                      placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false">
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('financing.startDate') {
            <th pResizableColumn pReorderableColumn pSortableColumn="financing.startDate" class="table-column custom-columns-small">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.financing.start' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="financing.startDate"></p-sortIcon>
                    <p-columnFilter [showApplyButton]="true" field="financingStartDate" type="date" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body" [hideOnClear]="true">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-datepicker [(ngModel)]="startFinancingStartDate" (onChange)="filter($event.value);" placeholder="{{ 'general.startDate' | translate }}" dateFormat="yy-mm-dd"></p-datepicker>
                        <p-datepicker [(ngModel)]="endFinancingStartDate" (onChange)="filter($event.value);" placeholder="{{ 'general.endDate' | translate }}" dateFormat="yy-mm-dd"></p-datepicker>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('financing.endDate') {
            <th pResizableColumn pReorderableColumn pSortableColumn="financing.endDate" class="table-column custom-columns-small">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.financing.end' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="financing.endDate"></p-sortIcon>
                    <p-columnFilter [showApplyButton]="true" field="financingEndDate" type="date" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body" [hideOnClear]="true">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-datepicker [(ngModel)]="startFinancingEndDate" (onChange)="filter($event.value);" placeholder="{{ 'general.startDate' | translate }}" dateFormat="yy-mm-dd"></p-datepicker>
                        <p-datepicker [(ngModel)]="endFinancingEndDate" (onChange)="filter($event.value);" placeholder="{{ 'general.endDate' | translate }}" dateFormat="yy-mm-dd"></p-datepicker>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('financing.cancellationDate') {
            <th pResizableColumn pReorderableColumn pSortableColumn="financing.cancellationDate" class="table-column custom-columns-big">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.financing.cancelationDate' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="financing.cancellationDate"></p-sortIcon>
                    <p-columnFilter [showApplyButton]="true" field="financingCancellationDate" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body" [hideOnClear]="true">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-datepicker [(ngModel)]="startFinancingCancellationDate" (onChange)="filter($event.value);" placeholder="{{ 'general.startDate' | translate }}" dateFormat="yy-mm-dd"></p-datepicker>
                        <p-datepicker [(ngModel)]="endFinancingCancellationDate" (onChange)="filter($event.value);" placeholder="{{ 'general.endDate' | translate }}" dateFormat="yy-mm-dd"></p-datepicker>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('financing.importService') {
            @if (isExtraGranted) {
              <th pResizableColumn pReorderableColumn pSortableColumn="financing.importService" class="table-column custom-columns-small">
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                    {{ 'tableManagement.financing.importService' | translate }}
                  </div>
                  <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center h-100">
                      <p-sortIcon field="financing.importService"></p-sortIcon>
                      <p-columnFilter field="financing.importService" type="numeric" matchMode="between" display="menu"
                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        <ng-template pTemplate="filter" let-filter>
                          <div class="d-flex flex-column">
                            <input type="number" [(ngModel)]="startImportService" placeholder="Min" (input)="filter.filter($event.target.value)" class="p-inputtext p-component">
                            <input type="number" [(ngModel)]="endImportService" placeholder="Max" (input)="filter.filter($event.target.value)" class="p-inputtext p-component mt-2">
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                  </div>
                </div>
              </th>
            }
          }

          @case ('financing.importFinancing') {
            @if (isExtraGranted) {
              <th pResizableColumn pReorderableColumn pSortableColumn="financing.importFinancing" class="table-column custom-columns-small">
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                    {{ 'tableManagement.financing.importFinancing' | translate }}
                  </div>
                  <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center h-100">
                      <p-sortIcon field="financing.importFinancing"></p-sortIcon>
                      <p-columnFilter field="financing.importFinancing" type="numeric" matchMode="between" display="menu"
                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        <ng-template pTemplate="filter" let-filter>
                          <div class="d-flex flex-column">
                            <input type="number" [(ngModel)]="startImportFinancing" placeholder="Min" (input)="filter.filter($event.target.value)" class="p-inputtext p-component">
                            <input type="number" [(ngModel)]="endImportFinancing" placeholder="Max" (input)="filter.filter($event.target.value)" class="p-inputtext p-component mt-2">
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                  </div>
                </div>
              </th>
            }
          }

          @case ('financing.totalImport') {
            @if (isExtraGranted) {
              <th pResizableColumn pReorderableColumn pSortableColumn="financing.totalImport" class="table-column custom-columns-small">
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                    {{ 'tableManagement.financing.totalImport' | translate }}
                  </div>
                  <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center h-100">
                      <p-sortIcon field="financing.totalImport"></p-sortIcon>
                      <p-columnFilter field="financing.totalImport" type="numeric" matchMode="between" display="menu"
                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        <ng-template pTemplate="filter" let-filter>
                          <div class="d-flex flex-column">
                            <input type="number" [(ngModel)]="startTotalImport" placeholder="Min" (input)="filter.filter($event.target.value)" class="p-inputtext p-component">
                            <input type="number" [(ngModel)]="endTotalImport" placeholder="Max" (input)="filter.filter($event.target.value)" class="p-inputtext p-component mt-2">
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                  </div>
                </div>
              </th>
            }
          }

          @case ('financing.monthlyFee') {
            @if (isCostGranted) {
              <th pResizableColumn pReorderableColumn pSortableColumn="financing.monthlyFee" class="table-column custom-columns-small">
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                    {{ (isExtraGranted ? 'tableManagement.financing.totalPlusVat' : 'tableManagement.financing.monthlyFee') | translate }}
                  </div>
                  <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center h-100">
                      <p-sortIcon field="financing.monthlyFee"></p-sortIcon>
                      <p-columnFilter field="financing.monthlyFee" type="numeric" matchMode="between" display="menu"
                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        <ng-template pTemplate="filter" let-filter>
                          <div class="d-flex flex-column">
                            <input type="number" [(ngModel)]="startMonthlyFee" placeholder="Min" (input)="filter.filter($event.target.value)" class="p-inputtext p-component">
                            <input type="number" [(ngModel)]="endMonthlyFee" placeholder="Max" (input)="filter.filter($event.target.value)" class="p-inputtext p-component mt-2">
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                  </div>
                </div>
              </th>
            }
          }

          @case ('vehicleAssignments[0].iva') {
            <th pResizableColumn pReorderableColumn class="table-column custom-columns-verysmall">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.financing.vat' | translate }}
                </div>
              </div>
            </th>
          }

          @case ('dateRegistered') {
            <th pResizableColumn pReorderableColumn pSortableColumn="dateRegistered" class="table-column custom-columns-small">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.createDate' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="dateRegistered"></p-sortIcon>
                    <p-columnFilter [showApplyButton]="true" field="dateRegistered" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body" [hideOnClear]="true">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-datepicker [(ngModel)]="startDateCreated" placeholder="{{ 'general.startDate' | translate }}" dateFormat="yy-mm-dd" (onChange)="filter($event.value);"></p-datepicker>
                        <p-datepicker [(ngModel)]="endDateCreated" placeholder="{{ 'general.endDate' | translate }}" dateFormat="yy-mm-dd" (onChange)="filter($event.value);"></p-datepicker>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('disabledDate') {
            <th pResizableColumn pReorderableColumn pSortableColumn="disabledDate" class="table-column custom-columns-small">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'tableManagement.disabledDate' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <div class="d-flex align-items-center h-100">
                    <p-sortIcon field="disabledDate"></p-sortIcon>
                    <p-columnFilter [showApplyButton]="true" field="disabledDate" matchMode="in" display="menu"
                      [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" appendTo="body" [hideOnClear]="true">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-datepicker [(ngModel)]="startDateDisabled" (onChange)="filter($event.value);" placeholder="{{ 'general.startDate' | translate }}" dateFormat="yy-mm-dd"></p-datepicker>
                        <p-datepicker [(ngModel)]="endDateDisabled" (onChange)="filter($event.value);" placeholder="{{ 'general.endDate' | translate }}" dateFormat="yy-mm-dd"></p-datepicker>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          }

          @case ('enabled') {
            <th pResizableColumn pReorderableColumn pSortableColumn="enabled" class="table-column custom-columns-small">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
                  {{ 'general.active' | translate }}
                </div>
                <div class="d-flex align-items-center h-100">
                  <p-sortIcon field="enabled"></p-sortIcon>
                  <p-columnFilter field="enabled" type="boolean" display="menu" [showApplyButton]="false">
                    <ng-template pTemplate="filter" let-filter="filterCallback">
                      <p-select [options]="optionsenabled" placeholder="{{ 'general.search' | translate }}"
                        (onChange)="filter($event.value)">
                        <ng-template let-option pTemplate="item">
                          <span [ngClass]="'p-ml-1 state-' + option.value">{{ option.label }}</span>
                        </ng-template>
                      </p-select>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </div>
            </th>
          }

        }
      }

    </tr>
  </ng-template>
  <!-- #endregion  -->

<!-- #region TABLE BODY DEFINITION -->
<ng-template pTemplate="body" let-vehicle>
  <tr class='p-selectable-row custom-rows' [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)='editVehicle(vehicle)'>
    <td pFrozenColumn style="border-right: 1px solid #8898AA !important; text-align: center;" class="custom-columns-small">{{vehicle.name}}</td>

    @for (field of orderedVisibleFields; track field) {
      @switch (field) {
        @case ('model.brand.name') {
          <td class="custom-columns-small"> {{!vehicle.model.brand ? '' : vehicle.model.brand.name}}</td>
        }
        @case ('model.name') {
          <td class="custom-columns-small">{{!vehicle.model ? '' : vehicle.model.name}}</td>
        }
        @case ('version.name') {
          <td class="custom-columns-medium">{{!vehicle.version ? '' : vehicle.version.name}}</td>
        }
        @case ('frameNumber') {
          <td class="custom-columns-big">{{vehicle.frameNumber}}</td>
        }
        @case ('status.name') {
          @if (isVehicleStateGranted) {
            <td class="custom-columns-big">
              <div class='d-flex row-cols-2 w-100 align-items-center'>
                <div class="status-marcha" [style]="{'--color': vehicle.status.color }"></div>
                <div>{{ vehicle.status.name }}</div>
              </div>
            </td>
          }
        }
        @case ('driver.employee.code') {
          <td class="custom-columns-medium">
            {{vehicle.driver ? vehicle.driver.employee.code : 'N/A'}}
          </td>
        }
        @case ('driver.employee.user.name') {
          <td class="custom-columns-big">
            {{ vehicle.driver ? vehicle.driver.employee.user.surname1 + ' ' + vehicle.driver.employee.user.surname2 + ', ' + vehicle.driver.employee.user.name : 'N/A'}}
          </td>
        }
        @case ('billingAccount.code') {
          <td class="custom-columns-small">{{vehicle.billingAccount.code}}</td>
        }
        @case ('billingAccount.name') {
          <td class="custom-columns-big">{{vehicle.billingAccount.name}}</td>
        }
        @case ('delegation.code') {
          @if (vehicle.delegation) {
            <td class="custom-columns-medium">{{vehicle.delegation.code}}</td>
          } @else if (vehicle.subDelegation) {
            <td class="custom-columns-medium">{{vehicle.subDelegation.delegation.code}}</td>
          } @else {
            <td class="custom-columns-medium">N/A</td>
          }
        }
        @case ('delegation.name') {
          @if (vehicle.delegation) {
            <td class="custom-columns-medium">{{vehicle.delegation.name}}</td>
          } @else if (vehicle.subDelegation) {
            <td class="custom-columns-medium">{{vehicle.subDelegation.delegation.name}}</td>
          } @else {
            <td class="custom-columns-medium">N/A</td>
          }
        }
        @case ('ceco.code') {
          <td class="custom-columns-medium">{{vehicle.ceco ? vehicle.ceco.code : 'N/A'}}</td>
        }
        @case ('ceco.description') {
          <td class="custom-columns-big">{{vehicle.ceco ? vehicle.ceco.description : 'N/A'}}</td>
        }
        @case ('financing.financingType.name') {
          <td class="custom-columns-big">
            {{ vehicle.renting ? ('tableManagement.financing.renting' | translate) : ('tableManagement.financing.own' | translate) }}
          </td>
        }
        @case ('financing.provider.name') {
          <td class="custom-columns-big">
            {{vehicle.financing ? vehicle.financing.provider.name : vehicle.renting ? 'N/A' : ('tableManagement.financing.own' | translate)}}
          </td>
        }
        @case ('financing.startDate') {
          <td style="justify-content: center;" class="custom-columns-small">
            {{vehicle.financing ? (vehicle.financing.startDate | date: 'dd/MM/yyyy') : 'N/A'}}
          </td>
        }
        @case ('financing.endDate') {
          <td style="justify-content: center;" class="custom-columns-small">
            {{vehicle.financing ? (vehicle.financing.endDate | date: 'dd/MM/yyyy') : 'N/A'}}
          </td>
        }
        @case ('financing.cancellationDate') {
          <td style="justify-content: center;" class="custom-columns-big">
            {{vehicle.financing ? (vehicle.financing.cancellationDate | date: 'dd/MM/yyyy') : 'N/A'}}
          </td>
        }
        @case ('financing.importService') {
          @if (isExtraGranted) {
            <td style="justify-content: center;" class="custom-columns-small">
              {{vehicle.financing ? vehicle.financing.importService : 'N/A'}}
            </td>
          }
        }
        @case ('financing.importFinancing') {
          @if (isExtraGranted) {
            <td style="justify-content: center;" class="custom-columns-small">
              {{vehicle.financing ? vehicle.financing.importFinancing : 'N/A'}}
            </td>
          }
        }
        @case ('financing.totalImport') {
          @if (isExtraGranted) {
            <td style="justify-content: center;" class="custom-columns-small">
              {{vehicle.financing ? vehicle.financing.totalImport : 'N/A'}}
            </td>
          }
        }
        @case ('financing.monthlyFee') {
          @if (isCostGranted) {
            <td style="justify-content: center;" class="custom-columns-small">
              {{vehicle.financing ? vehicle.financing.monthlyFee : 'N/A'}}
            </td>
          }
        }
        @case ('vehicleAssignments[0].iva') {
          <td style="justify-content: center;" class="custom-columns-verysmall">
            {{ vehicle.vehicleAssignments.length > 0 ? extractNumericValue(vehicle.vehicleAssignments[0].iva) : 'N/A'}}
          </td>
        }
        @case ('dateRegistered') {
          <td style="justify-content: center;" class="custom-columns-small">{{vehicle.dateRegistered | date: 'dd/MM/yyyy'}}</td>
        }
        @case ('disabledDate') {
          <td style="justify-content: center;" class="custom-columns-small">{{vehicle.disabledDate | date: 'dd/MM/yyyy'}}</td>
        }
        @case ('enabled') {
          <td style="justify-content: center;" class="custom-columns-small">
            <div class="d-flex justify-content-center align-items-center">
              <i class="pi"
              [ngClass]="{'true-icon pi-check-circle': vehicle.enabled, 'false-icon pi-times-circle': !vehicle.enabled}"></i>
            </div>
          </td>
        }
      }
    }

  </tr>
</ng-template>
<!-- #endregion -->

<!-- <ng-template #na>
<td>N/A</td>
</ng-template> -->

<!------ TABLE EMPTY MESSAGE ---------------------------------------------------------------->
<ng-template pTemplate="emptymessage">
  <tr>
    <td [attr.colspan]="numColumns" class="p-0">
      <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
					{{ 'table.tableEmptyMessage' | translate }}!
				</div>
    </td>
  </tr>
</ng-template>

<!------ FOOTER ----------------------------------------------------------------------------->
<ng-template pTemplate="footer">
  <tr>
    <td [attr.colspan]="numColumns" class="p-0">
      <div class="d-flex flex-row align-items-center p-3 gap-3">
        @if (isCreateGranted) {
          <app-table-add-button [text]=" 'tableManagement.vehicle.vehicle' | translate "
          (btnClick)="createVehicle()"></app-table-add-button>
        }
        <app-table-excel-button class="buttonTableExcel"
        (btnClick)="exportExcel()"></app-table-excel-button>
      </div>
    </td>
  </tr>
</ng-template>

</p-table>

<app-inventory-vehicle-form [clientId]="selectedClient">
</app-inventory-vehicle-form>
<!-- <app-vehicle-info-card></app-vehicle-info-card> -->

